'use client';

import s from 'Bomdisoft/shared/painted-title.module.css';
import { TextPaint } from '@bomdisoft/components';

const BRAND_FILL = '#8b5cf6';

/**
 * Paints the first part of a two-part heading (e.g. "Our" in "Our Products") with the
 * brand brush stroke. Inherits the heading's font size/weight and text color.
 */
export const PaintedTitle = ({ text }: { text: string }) => (
  <span className={s.wrap}>
    <TextPaint fillColor={BRAND_FILL} text={text} variant='dryBrush' />
  </span>
);
